import { render, staticRenderFns } from "./CardCallback.vue?vue&type=template&id=1f999a6f&"
import script from "./CardCallback.vue?vue&type=script&lang=js&"
export * from "./CardCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports